import { ref, computed } from 'vue'
import { useApolloClient } from '@vue/apollo-composable'
import { container, TYPES } from '@/libs/di/inversify.config'

import type { KarteUser, KarteID, DiagnosisSummary } from '@/types/app'
import { FetchKarteOnUseKarteUserDetailDocument } from './useKarteUserDetail.generated'
import type { FetchKarteOnUseKarteUserDetailQuery } from './useKarteUserDetail.generated'

export const useKarteUserDetail = (
  onDetailLoadError: (error: Error) => void
) => {
  const currentUserDiagnosisSummary = ref<Maybe<DiagnosisSummary>>(undefined)
  const currentUser = ref<Maybe<KarteUser>>(undefined)
  const karte = ref<FetchKarteOnUseKarteUserDetailQuery['user']['karte']>(null)

  const isDetailFetching = ref(false)
  const isDetailReady = computed(
    () =>
      currentUserDiagnosisSummary.value !== undefined && !isDetailFetching.value
  )

  const apollo = useApolloClient()
  const fetchUserDetail = async (karteId: KarteID): Promise<void> => {
    try {
      isDetailFetching.value = true
      const { summary, user } = await container
        .get(TYPES.UserUsecase)
        .getDiagnosisSummaryByKarteId(karteId)
      currentUserDiagnosisSummary.value = summary
      currentUser.value = user

      const { data } =
        await apollo.client.query<FetchKarteOnUseKarteUserDetailQuery>({
          query: FetchKarteOnUseKarteUserDetailDocument,
          variables: {
            id: user.id.toString(),
          },
        })
      karte.value = data.user.karte
    } catch (error) {
      onDetailLoadError(error as Error)
    } finally {
      isDetailFetching.value = false
    }
  }

  // FIXME:
  // karteはgqlから取得したもの。
  // KarteUserDetailViewで、KarteUserConcernが求める型がgqlから取得したものなので、
  // ここで返すようにする。
  // KarteUserConcernはcurrentUser.karteを渡さない
  // ここらへんの整理はこのあとやる
  return {
    currentUser,
    currentUserDiagnosisSummary,
    karte,
    fetchUserDetail,
    isDetailReady,
  }
}
